<template>
    <b-card style="overflow-y:auto; ">
        <b-card-title> {{ $t("Filters") }}</b-card-title>
        <b-card-text>
            <div class="multi-range-price mt-3">
                <h4 class="filter-title mt-0"> {{ $t("Multi range") }}</h4>
                <BFormRadioGroup v-model="filterPrice" 
                    class="price-range-defined-radio-group ¡" stacked >
                    <!-- <BFormRadio key="Todas" :value="{min:0, max:100000}" > Todas </BFormRadio> -->
                    <BFormRadio v-for="p in priceRangeOptions" :key="p.text"  :value="p.value" >{{ p.text }} </BFormRadio>
                </BFormRadioGroup>
            </div>
            <div class="multi-range-price mt-3" v-if="selectedItems=='courses'">
                <h4 class="filter-title mt-0"> {{ $t("Sections") }}</h4>
                <BFormRadioGroup v-model="filterSection" 
                    class="price-range-defined-radio-group ¡" stacked >
                    <BFormRadio key="Todas" label="Todas" :value="''" > Todas </BFormRadio>
                    <BFormRadio v-for="s in sections" :key="s.id" :label="s.name" :value="s.id" >{{ s.name }} </BFormRadio>
                </BFormRadioGroup>
            </div>
            <div class="multi-range-price mt-3" v-if="selectedItems=='products'">
                <h4 class="filter-title mt-0"> {{ $t("Families") }}</h4>
                <BFormRadioGroup v-model="filterFamily" 
                    class="price-range-defined-radio-group ¡" stacked >
                    <BFormRadio key="Todas" label="Todas" :value="''" > Todas </BFormRadio>
                    <BFormRadio v-for="f in families" :key="f.id" :label="f.name" :value="f.id" >{{ f.name }} </BFormRadio>
                </BFormRadioGroup>
            </div>
            
        </b-card-text>
    </b-card>
</template>

<script>

import {
   BFormRadioGroup, BFormRadio, BRow, BCol, BInputGroup, BFormInput, BCard, BCardBody, BLink, BImg, BCardText, BButton, BPagination,BInputGroupAppend,BDropdownItem,BDropdown, BCardTitle
} from 'bootstrap-vue'
import { ref, watch, inject} from '@vue/composition-api';
import i18n from "@/libs/i18n";



export default {
    components: { BCard, BCardBody, BLink, BImg, BCardText, BButton, BFormRadioGroup, BFormRadio, BRow, BCol, BInputGroup, BInputGroupAppend, BFormInput, BPagination, BDropdownItem, BDropdown, BCardTitle },
    props: ['filters', 'filterOptions'],
    emits: ['filters-changed'] ,
    setup(props,{emit} ){

        const filterFamily=ref('')
        const filterSection=ref('')
        const filterPrice=ref({ text: 'Todos', value: {min:0, max:10000000} })
        const priceRangeOptions= [
            { text: i18n.t('All'), value: {min:0, max:10000000} },
            { text: '<= 10€', value: {min:0.001, max:10}  },
            { text: '10€ - 100€', value: {min:10, max:100} },
            { text: '100€ - 500€', value: {min:100, max:500} },
            { text: '>= 500€', value: {min:500, max:10000000} },
        ]
        const sections=inject("sections")
        const families=inject("families")
        const selectedItems=inject("selectedItems")


  
        watch([filterFamily,filterPrice, filterSection], () => {
            emit("filters-changed", filterPrice, filterFamily.value, filterSection.value)
        })

        watch(selectedItems,() => {
          filterFamily.value=''
          filterSection.value=''
          filterPrice.value={ text: 'Todos', value: {min:0, max:10000000} }
          emit("filters-changed", filterPrice, filterFamily.value, filterSection.value)
        })

       

        return {
            filterPrice,
            filterFamily,
            filterSection,
            sections,
            families,
            priceRangeOptions,
            selectedItems
        }
    }
}
</script>
